import { useQuery } from '@tanstack/react-query'
import { projectsApi, type DeveloperDashboardResponse, type ProjectDetail } from '@/lib/api'

/**
 * Query for fetching all marketplace projects
 */
export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await projectsApi.getAll()
      return response.data.results || response.data
    },
  })
}

/**
 * Query for fetching a specific project by ID
 */
export function useProject(projectId: number | null | undefined) {
  return useQuery({
    queryKey: ['project', projectId],
    enabled: typeof projectId === 'number',
    queryFn: async () => {
      if (typeof projectId !== 'number') {
        throw new Error('Project id is required')
      }
      const response = await projectsApi.get(projectId)
      return response.data
    },
  })
}

/**
 * Query for the customer dashboard project list
 */
export function useCustomerProjects() {
  return useQuery({
    queryKey: ['projects', 'customer-dashboard'],
    queryFn: async (): Promise<ProjectDetail[]> => {
      const response = await projectsApi.getCustomerDashboard()
      return response.data.projects
    },
  })
}

/**
 * Query for the developer dashboard project list
 */
export function useDeveloperProjects() {
  return useQuery({
    queryKey: ['projects', 'developer-dashboard'],
    queryFn: async (): Promise<DeveloperDashboardResponse> => {
      const response = await projectsApi.getDeveloperDashboard()
      return response.data
    },
  })
}
